var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grap-pdf"},[_c('div',[_c('Common',{attrs:{"isShow":false},on:{"loaded":_vm.onLoaded}})],1),_vm._v(" "),_c('div',{staticClass:"page"},[_c('Chart',{attrs:{"totalPage":_vm.totalPage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }